import { StyleSheet } from 'aphrodite'
import { Common } from 'styles'

const styles = StyleSheet.create({
  menu: {
    order: -1,
    backgroundColor: '#fff',
    borderRight: `1px solid ${Common.borderColor}`,
    overflow: 'auto',
    zIndex: 85,
    transition: '500ms ease-out',
    height: `100%`
  },
  menuHover: {
    position: 'fixed'
  },
  mainTree: {
    width: 'auto',
    margin: '10px 0 0 0',
    padding: 0
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Menu/styles.js